const breadCrumb = "Exames - Exames para a Turma";

const routes = [
  {
    path: "/exame-turma",
    name: "exame-turma",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameTurma/ExameTurmaHome.vue"),
  },
  {
    path: "/exame-turma/novo",
    name: "exame-turma-novo",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameTurma/ExameTurmaCad.vue"),
  },
  {
    path: "/exame-turma/consulta/:exame_id",
    name: "exame-turma-consulta",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameTurma/ExameTurmaConsulta.vue"),
  },
  {
    path: "/exame-turma/editar/:exame_id",
    name: "exame-turma-editar",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameTurma/ExameTurmaEditar.vue"),
  },
  {
    path: "/exame-turma/:exame_id/lancamento-resultados",
    name: "lancamento-resultados",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ExameTurma/LancamentoResultadosExameTurmas.vue"),
  },
  {
    path: "/exame-turma/:exame_id/definir-disciplinas",
    name: "exame-turma-definir-disciplinas",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ExameTurma/DefinirDisciplinasExameTurma.vue"),
  },
  {
    path: "/exame-turma/:exame_id/incluir-disciplinas",
    name: "exame-turma-incluir-disciplinas",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ExameTurma/IncluirDisciplinasExameTurma.vue"),
  },
  {
    path: "/exame-turma/:exame_id/inscrever-aluno",
    name: "exame-turma-inscrever-aluno",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameTurma/InscricaoAlunoExameTurma.vue"),
  },
  {
    path: "/exame-turma/:exame_id/alunos/:turma_id",
    name: "exame-turma-inscrever-alunos-turma",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ExameTurma/InscricaoAlunoExameTurmaListaAlunos.vue"),
  },
  {
    path: "/exame-turma/:exame_id/alunos/:turma_id/incluir",
    name: "exame-turma-inscrever-alunos-turma-incluir",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ExameTurma/InscricaoAlunoExameTurmaListaAlunosInclusao.vue"
      ),
  },
  {
    path: "/exame-turma/relacao-alunos-turma/:exame_id",
    name: "exame-turma-relacao-alunos-turma",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameTurma/RelacaoAlunosExameTurma.vue"),
  },
  {
    path: "/exame-turma/:exame_id/lancamento-resultados/:turma_id",
    name: "lancamento-resultados-exame-turma",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ExameTurma/LancamentoResultadosExameTurmaAlunos.vue"),
  },
  {
    path: "/exame-turma/:exame_id/lancamento-resultados/:turma_id/:aluno_id",
    name: "lancamento-resultados-exame-turma-aluno",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import("@/views/ExameTurma/LancamentoResultadosExameTurmaAluno.vue"),
  },
  {
    path: "/exame-turma/:exame_id/ata-exame",
    name: "ata-exame-turma",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () => import("@/views/ExameTurma/AtaExameTurma.vue"),
  },
];

export default routes;
